import React, { forwardRef } from 'react'

import classNames from 'classnames'

import { Box } from 'ui/components/Box'
import { useTheme } from 'ui/styling/themes/useTheme'

import * as Parts from './Modal.parts'

import { OverlayStyles } from './Modal.css'

type ModalContentRef = HTMLDivElement

type ModalContentProps = React.ComponentPropsWithoutRef<typeof Parts.Content> & {
    zIndex?: number
    modal?: boolean
}

export const ModalContent = forwardRef<ModalContentRef, ModalContentProps>(
    ({ zIndex, modal, ...props }, ref) => {
        const { themeClassName } = useTheme()

        const OverlayComponent = modal ? Parts.Overlay : Box

        return (
            <Parts.Portal>
                <OverlayComponent
                    className={classNames(
                        'ag-custom-component-popup',
                        OverlayStyles.styleFunction({}),
                        themeClassName
                    )}
                    style={{ zIndex }}
                >
                    <Parts.Content ref={ref} {...props} />
                </OverlayComponent>
            </Parts.Portal>
        )
    }
)
